/**
     * NotificationSent.contract.ts — Event Contract System™ (generation v1).
     * A user-facing announcement. Deliberately open payload: every module attaches its own detail fields beside the mandatory kind.
     */

    import type { EventContract } from '../EventContractRegistry';

    export const NotificationSentContract: EventContract = {
      name: 'NotificationSent',
      version: 1,
      description: "A user-facing announcement. Deliberately open payload: every module attaches its own detail fields beside the mandatory kind.",
      publishers: ["core","planner","wallet","visa","stay","connect","career","network","health","marketplace","passport"],
      subscribers: ["module:network","dev-center:live-feed"],
      fields: [
        { name: 'kind', type: 'string', required: true, description: "Notification discriminator (e.g. base-ready, engine-failure, planner kinds)" },
    { name: 'message', type: 'string', required: false, description: "Human-readable announcement text" },
      ],
      allowExtraFields: true,
      timestampPolicy: "Publisher's now — the moment the announcement is raised.",
      stability: 'stable',
      deprecated: false,
      example: {"kind":"base-ready","message":"Lisbon is ready."},
    };
    